import { render, staticRenderFns } from "./StadiumInfo.vue?vue&type=template&id=1b8d116f&"
import script from "./StadiumInfo.vue?vue&type=script&lang=js&"
export * from "./StadiumInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports